import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';

import { CatalystLogo } from '../components/ui/CatalystLogo.js';
import { Spinner } from '../components/ui/Spinner.js';
import { loginRequest } from './msalConfig.js';

/** Unauthenticated landing page with a single Microsoft sign-in action. */
export function LoginPage(): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const isBusy = inProgress !== InteractionStatus.None;

  const signIn = (): void => {
    void instance.loginRedirect(loginRequest);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl ring-1 ring-slate-200">
        <div className="mb-6 flex flex-col items-center text-center">
          <h1 className="flex items-center justify-center gap-2.5">
            <CatalystLogo className="h-11 w-auto text-slate-900" />
            <span className="text-3xl font-light tracking-wide text-slate-500">PSA</span>
          </h1>
          <p className="mt-3 text-sm text-slate-500">Sign in with your work account to continue.</p>
        </div>
        <button
          type="button"
          onClick={signIn}
          disabled={isBusy}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isBusy ? <Spinner className="h-4 w-4 text-white" /> : null}
          {isBusy ? 'Signing in…' : 'Sign in with Microsoft'}
        </button>
      </div>
    </div>
  );
}
